export default "__VITE_ASSET__8yJLNr4i__"